module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Chapter-Name"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-section-head"
  }, [_c('a', {
    attrs: {
      "href": "#/spousecalls3#_idTOCAnchor-1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-section-head"
  }, [_c('a', {
    attrs: {
      "href": "#/spousecalls4"
    }
  }, [_vm._v("Home Numbers: Family and Friendship")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('a', {
    attrs: {
      "href": "#/spousecalls5#_idTOCAnchor-4"
    }
  }, [_vm._v("Dream Houses")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('a', {
    attrs: {
      "href": "#/spousecalls6#_idTOCAnchor-5"
    }
  }, [_vm._v("Mom’s Love Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('a', {
    attrs: {
      "href": "#/spousecalls7#_idTOCAnchor-6"
    }
  }, [_vm._v("Peace Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('a', {
    attrs: {
      "href": "#/spousecalls8#_idTOCAnchor-7"
    }
  }, [_vm._v("Worth More Than a Thousand Words")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls9#_idTOCAnchor-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Strangers on This Train")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls10#_idTOCAnchor-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Family Forge")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls11#_idTOCAnchor-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Lunch")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls12#_idTOCAnchor-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("College Culture Shock")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls13#_idTOCAnchor-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strings Attached")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls14#_idTOCAnchor-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Am Somebody")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls15#_idTOCAnchor-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver and Gold: A Circle of Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls16#_idTOCAnchor-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Goes Around Comes Around")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls17#_idTOCAnchor-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-section-head"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 411: Facts of Military Life")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls19#_idTOCAnchor-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trial by Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls20#_idTOCAnchor-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Real Thing?")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls21#_idTOCAnchor-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special Needs, Special Dad")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls22#_idTOCAnchor-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Were Thrifty Before It Was Nifty")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls23#_idTOCAnchor-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs. Doolittle")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls24#_idTOCAnchor-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spell It Out With Real Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls25#_idTOCAnchor-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Way Glenn Miller Played")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls26#_idTOCAnchor-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stay-at-Home Dads")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls27#_idTOCAnchor-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Macho, Macho Spouse")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls28#_idTOCAnchor-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welcome to the Table")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls29#_idTOCAnchor-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stars and Stripes Forever")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls30#_idTOCAnchor-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stand and Deliver")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls31#_idTOCAnchor-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Military Moms")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls32#_idTOCAnchor-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ID Cards and My True Colors")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-section-head"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Area Codes: Moving and Travel")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls34#_idTOCAnchor-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Empty Houses")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls35#_idTOCAnchor-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Small World")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls36#_idTOCAnchor-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not the Real Me")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls37#_idTOCAnchor-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foreign")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls38#_idTOCAnchor-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Farewell to the Stairwell")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls39#_idTOCAnchor-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Land of the Free, Home of the Barnes Family")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls40#_idTOCAnchor-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traveling Exhibits of Our Past")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls41#_idTOCAnchor-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking Inventory")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls42#_idTOCAnchor-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Earning Our Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls43#_idTOCAnchor-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visiting Hometowns and Coming Home")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls44#_idTOCAnchor-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lego Blocks and Loose Screws")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-section-head"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Duty Calls: Service and Sacrifice")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls46#_idTOCAnchor-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Things That Don’t Change")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls47#_idTOCAnchor-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Bags")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls48#_idTOCAnchor-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homecomings: The Nitty Gritty")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls49#_idTOCAnchor-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Telling Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls50#_idTOCAnchor-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gary and Lt. Dan")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls51#_idTOCAnchor-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Measure of Sisterhood")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls52#_idTOCAnchor-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rolling Out the Red Carpet")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls53#_idTOCAnchor-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Homecoming: Stories to Tell")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls54#_idTOCAnchor-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pages From Life")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls55#_idTOCAnchor-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invasion: Ten Years Later")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls56#_idTOCAnchor-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ernie Pyle: Across Many Aprils")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls57#_idTOCAnchor-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bobby’s Flag")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls58#_idTOCAnchor-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TAPS: More Than a Sad Song")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls59#_idTOCAnchor-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words of Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls60#_idTOCAnchor-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invisible Wounds: Voices of Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-section-head"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leaving Messages: Meaningful Days")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls62#_idTOCAnchor-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Year, Old Friends: Not the Same Auld Lang Syne")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls63#_idTOCAnchor-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fourteen Bucks and a Dozen Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls64#_idTOCAnchor-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cross Purposes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls65#_idTOCAnchor-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Blossom Time")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls66#_idTOCAnchor-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting for Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls67#_idTOCAnchor-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memorial Day")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls68#_idTOCAnchor-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Star Spangled Banner")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls69#_idTOCAnchor-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Absence Makes the Dad Grow Fonder")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls70#_idTOCAnchor-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Born on the Fourth")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls71#_idTOCAnchor-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Election Day, Veterans Day")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls72#_idTOCAnchor-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giving Thanks")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls73#_idTOCAnchor-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Large Legend, Small Gifts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls74#_idTOCAnchor-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Child Is Born")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-columns"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls75#_idTOCAnchor-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decorations for Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-section-head"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls76#_idTOCAnchor-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-section-head"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls77#_idTOCAnchor-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-section-head"
  }, [_c('span', {
    attrs: {
      "href": "#/spousecalls78#_idTOCAnchor-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e38d6c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spousecalls2.vue
// module id = 63
// module chunks = 0